import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';

var TitleSection = function TitleSection() {
  return import(
  /* webpackChunkName: "title-section" */
  '~/components/atoms/Editorial/TitleSection.vue');
};

var SubtitleSection = function SubtitleSection() {
  return import(
  /* webpackChunkName: "subtitle-section" */
  '~/components/atoms/Editorial/SubtitleSection.vue');
};

var MdmLink = function MdmLink() {
  return import(
  /* webpackChunkName: "mdm-link" */
  '~/components/atoms/MdmLink.vue');
};

export default {
  name: 'OfferInspirations',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    MdmLink: MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      return {
        text: this.payload.primary.title_text[0] || {},
        color: this.payload.primary.title_color || ''
      };
    },
    subtitle: function subtitle() {
      return {
        text: this.payload.primary.subtitle_text[0] || {},
        color: this.payload.primary.subtitle_color || ''
      };
    },
    description: function description() {
      return {
        text: Object.keys(this.payload.primary.description).length === 0 ? '' : this.payload.primary.description[0].text
      };
    },
    elements: function elements() {
      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          imgSrc: "".concat(large),
          imgSrcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          alt: item.alt || '',
          title: Object.keys(item.title).length === 0 ? '' : item.title[0].text,
          subtitle: Object.keys(item.subtitle).length === 0 ? '' : item.subtitle[0].text,
          url: item.url.url || '',
          tracking: {
            data: {
              event_category: item.event_category || '',
              event_action: item.event_action || '',
              event_label: item.event_label || ''
            }
          }
        };
      });
    }
  }
};